module.exports = __webpack_public_path__ + "static/img/title.8f4351a1.png";